<template>
    <div class="Menu">
        <v-snackbar
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          v-model="snackbar.show"
        >
          {{ snackbar.message }}
        </v-snackbar>
        <v-navigation-drawer 
        app
        v-model="drawer"
        touch-action: auto
        temporary
        disable-resize-watcher
        width="400"
        >
        <v-card
          height="100%"
          width="auto"
          class="mx-auto"
        >
            <v-list-item
            style="background: #037769;"
            >
              <v-list-item-content>
                <v-list-item-title
                class="text-h6 white--text"
                >
                  {{$t('menu')}}
                </v-list-item-title>
                <v-list-item-subtitle
                  class="white--text"
                >
                   {{$t('(HIES/BA)')}} 
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            
            <!-- <v-list
              dense
              nav
            >
              <v-list-item
                v-for="item in navsidebarmenus"
                :key="item.title"
                @click="goToRoute(item.url)"
              > 
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{$t(item.title)}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->

              <v-list>
                  <div v-for="(link, i) in navsidebarmenus" :key="i.text">
                    
                      <v-list-item
                          v-if="!link.subLinks"
                          :key="i"
                          @click="goToRoute(link.to)"
                          avatar
                          class="v-list-item"
                      >
                          <v-list-item-icon>
                            <v-icon>{{link.icon}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title style="font-size: 20px">{{$t(link.text)}}</v-list-item-title>
                          </v-list-item-content>
                      </v-list-item>

                      <v-list-group
                          v-else
                          :key="link.text"
                          no-action
                      >
                          <template v-slot:activator>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-action>
                                    <v-icon>{{ link.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title style="font-size: 20px">{{$t(link.text)}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                            <v-divider :thickness="4" color="#BBBBBB"></v-divider>
                            <v-list rounded v-for="sublink in link.subLinks" :key="sublink.text" > 
                              <v-list-item-group color="primary"> 
                                <v-list-item @click="goToRoute(sublink.to)">
                                    <v-list-item-icon>
                                      <v-icon>{{sublink.icon}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title style="font-size: 20px">{{$t(sublink.text)}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item> 
                              </v-list-item-group> 
                            </v-list>`

                      </v-list-group>
                    <v-divider :thickness="8" color="#BBBBBB"></v-divider>
                  </div>
              </v-list>

            
        </v-card>
        </v-navigation-drawer>
        <v-app-bar 
        app
        color="#037769"
        dark
        >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title style="font-size: 24px;">{{$t(' (HIES/BA)')}} </v-toolbar-title>
        <v-spacer></v-spacer>
        <Switchlang></Switchlang>
        &nbsp;{{nama.toUpperCase()}}&nbsp;- ({{peranan}})
        <v-menu
            left
            bottom
        >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
            >
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            </template>

            <v-list>
            <v-list-item
                v-for="headers in senaraiheader"
                :key="headers.title"
                @click="menuActionClick(headers.action)"
            >
                <v-list-item-title>{{$t(headers.title)}} </v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
        </v-app-bar>
        
        <v-dialog
          v-model="dialogkemaskinimaklumatpengguna"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-form ref="formkemaskinimaklumatpengguna">
            <v-card-title>
                <span class="text-h5">{{$t('kemaskinimaklumatpengguna')}}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                        v-model="semakkemaskiniemel"
                        v-show="false">
                      </v-text-field>
                      <v-text-field
                      outlined dense
                      v-model="kemaskiniemel"
                      :rules="[required('emel'), kemaskiniemeltidaksama, rules.email]"
                      v-bind:label="$t('emel')"
                      :messages="msgkemaskiniemel"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskininama"
                      :rules="[required('nama')]"
                      v-bind:label="$t('nama')"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="katalaluan"
                      :rules="[required('katalaluan')]"
                      v-bind:label="$t('katalaluan')"
                      :type="paparkatalaluan ? 'text' : 'password'"
                      :append-icon="paparkatalaluan ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluan = !paparkatalaluan"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogkemaskinimaklumatpengguna = false"
              >
               {{$t('tutup')}} 
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="hantarkemaskinipengguna()"
              >
                {{$t('kemaskini')}} 
              </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        
        <v-dialog
          v-model="dialogkemaskinikatalaluan"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-form ref="formkemaskinikatalaluan">
            <v-card-title>
                <span class="text-h5">{{$t('kemaskinikatalaluan')}}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluankatalaluansemasa"
                      v-bind:label="$t('katalaluansemasa')"
                      :rules="[required('katalaluansemasa'), kemaskinikatalaluansemasatidaksama, minkatalaluan]"
                      :messages="msgkemaskinikatalaluansemasatidaksama"
                      :type="paparkatalaluansemasa ? 'text' : 'password'"
                      :append-icon="paparkatalaluansemasa ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluansemasa = !paparkatalaluansemasa"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluankatalaluanbaru"
                      v-bind:label="$t('katalaluanbaru')"
                      :rules="[required('katalaluanbaru'), minkatalaluan]"
                      :type="paparkatalaluanbaru ? 'text' : 'password'"
                      :append-icon="paparkatalaluanbaru ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluanbaru = !paparkatalaluanbaru"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluanmasukkatalaluanbaru"
                      v-bind:label="$t('masuksemulakatalaluanbaru')"
                      :type="paparkatalaluansemulabaru ? 'text' : 'password'"
                      :append-icon="paparkatalaluansemulabaru ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluansemulabaru = !paparkatalaluansemulabaru"
                      :rules="[required('masuksemulakatalaluanbaru'), minkatalaluan, katalaluanbarusama(kemaskinikatalaluankatalaluanbaru,kemaskinikatalaluanmasukkatalaluanbaru)]"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogkemaskinikatalaluan = false"
                >
                    {{$t('tutup')}} 
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="hantarkemaskinikatalaluan"
                >
                    {{$t('hantar')}} 
                </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
    </div>  
</template>
<script>
import axios from '../../plugins/axios'
import openSistemAnalisis from '@/services/ssoAnalisis'
import navsidebar from '@/model/navsidebar.js'
// import removelocalstorage from '@/services/removelocalstorage.js'
import Switchlang  from "@/components/Switchlang/switchlang"
import i18n from '@/i18n'
export default {
  name: 'Menu',
  components: {
    Switchlang
  },
  data: () => ({
    snackbar: "",
    senaraiheader: [],
    paparkatalaluan: false,
    paparkatalaluansemasa: false,
    paparkatalaluanbaru: false,
    paparkatalaluansemulabaru: false,
    kemaskinikatalaluanmasukkatalaluanbarushow: false,
    dialogkemaskinikatalaluan: false,
    dialogkemaskinimaklumatpengguna: false,
    semakemel: false,
    semakkemaskiniemel: '',
    kemaskiniemel: '',
    kemaskininama: '',
    katalaluan: '',
    kemaskinikatalaluankatalaluansemasa: '',
    kemaskinikatalaluankatalaluanbaru: '',
    kemaskinikatalaluanmasukkatalaluanbaru: '',
    localstoragename: [],

    msgkemaskiniemel: '',
    kemaskiniemeltidaksama: () => true || this.msgkemaskiniemel,

    msgkemaskinikatalaluansemasatidaksama: '',
    kemaskinikatalaluansemasatidaksama: () => true || this.msgkemaskinikatalaluansemasatidaksama,
    msgkemaskinikatalaluanbarutidaksama: '',
    drawer: false,
    group: null,
    navsidebarmenus: '',
    nama: '',
    peranan: '',
    header: [
        { title: 'kemaskinimaklumatpengguna', action: "kemaskinimaklumatpengguna"},
        { title: 'kemaskinikatalaluan', action: "kemaskinikatalaluan"},
        { title: 'logkeluar', action: "logkeluar"}     
    ],
    right: null,
    required(text){
      return (v) => 
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalahdiperlukan')}`
    },
    minkatalaluan: value => {
        return value.length >= 6 || `${i18n.t('minimum')} 6 characters`
    },
    katalaluanbarusama(a,b){
        return (a === b) || `${i18n.t('katalaluanbaru')} ${i18n.t('tidakpadan')}` 
    },
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
      }
    },
  }),
  beforeMount(){
    this.navsidebar()
  },
  methods:{
    async menuActionClick(action){
      switch (action) {
        case "bukasistemanalisis":
          // Logic lives in the service (@/services/ssoAnalisis); this only reacts.
          try {
            await openSistemAnalisis()
          } catch (err) {
            this.snackbar = {
              message: (err.response && err.response.data && err.response.data.message) || err.message || 'Could not open Sistem Analisis',
              timeout: 4000,
              color: 'error',
              show: true
            }
          }
          break;
        case "logkeluar":
          await axios.get(`${process.env.VUE_APP_API_URL}/auth/logkeluar`)
          // this.localstoragename = await removelocalstorage().then()
          //  this.localstoragename.map(function(value) {
          //   window.localStorage.removeItem(`${value}`);
          // });
          window.localStorage.clear();
          this.$router.push('/')
          break;
        case "kemaskinikatalaluan":
          this.dialogkemaskinikatalaluan = true
          this.msgkemaskinikatalaluansemasatidaksama = ''
          this.kemaskinikatalaluansemasatidaksama = true
          break;
        case "kemaskinimaklumatpengguna":
          this.dialogkemaskinimaklumatpengguna = true
          try{
            await axios.get(`${process.env.VUE_APP_API_URL}/penggunasistem/paparmaklumatpenggunaid`).then(res=>{
              this.semakkemaskiniemel = res.data.emel
              this.kemaskiniemel = res.data.emel
              this.kemaskininama = res.data.nama
            })
          } catch(err){
            alert(err)
          }
          break;
        default:
          break;
      }
    },
    async navsidebar(){
      const datapengguna = JSON.parse(window.localStorage.getItem('user'))
      this.nama = datapengguna.name
      this.peranan = datapengguna.role
      const navsidebarmenu = await navsidebar(datapengguna.role).then()
      //console.log(navsidebarmenu)
      this.navsidebarmenus = navsidebarmenu
      if(this.peranan === 'RESPONDENT'){
        this.senaraiheader = [
            { title: 'logkeluar', action: "logkeluar"}     
        ]
      } else {
        this.senaraiheader = [
            { title: 'Buka Sistem Analisis', action: "bukasistemanalisis"},
            { title: 'kemaskinimaklumatpengguna', action: "kemaskinimaklumatpengguna"},
            { title: 'kemaskinikatalaluan', action: "kemaskinikatalaluan"},
            { title: 'logkeluar', action: "logkeluar"}     
        ]
      }
    },
    goToRoute(url){
      this.$router.push(`/${i18n.locale}/${url}`, () => {})
    },
    async hantarkemaskinikatalaluan(){
        if(this.$refs.formkemaskinikatalaluan.validate()){
          const datakemaskinikatalaluan = {
            'kemaskinikatalaluankatalaluansemasa': this.kemaskinikatalaluankatalaluansemasa,
            'kemaskinikatalaluankatalaluanbaru': this.kemaskinikatalaluankatalaluanbaru,
            'kemaskinikatalaluanmasukkatalaluanbaru': this.kemaskinikatalaluanmasukkatalaluanbaru
          }
          const datakemaskini = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/tetapkansemulakatalaluanmanual`, datakemaskinikatalaluan)
          console.log(datakemaskini.data.status)
          if(datakemaskini.data.status){
            this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
            };
            this.dialogkemaskinikatalaluan = false
            this.kemaskinikatalaluankatalaluansemasa = ''
            this.kemaskinikatalaluankatalaluanbaru = ''
            this.kemaskinikatalaluanmasukkatalaluanbaru = ''
            this.$refs.formkemaskinikatalaluan.resetValidation()
            // this.$refs.formkemaskinikatalaluan.reset()
          }
        }
    },
    async hantarkemaskinipengguna(){
        if(this.$refs.formkemaskinimaklumatpengguna.validate()){
          try{
            if(this.semakkemaskiniemel !== this.kemaskiniemel){
              this.semakemel = true
            }
            const datapengguna = {
              semakkemaskiniemel: this.semakemel,
              kemaskiniemel: this.kemaskiniemel,
              kemaskininama: this.kemaskininama,
              katalaluan: this.katalaluan
            }
            await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/kemaskininamaemelpengguna`, datapengguna).then(res => {
              console.log(res.data.status)
              if(res.data.status){
                this.$refs.formkemaskinimaklumatpengguna.reset()
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: `${i18n.t('berjaya')} ${i18n.t('kemaskini')}`,
                    timeout: 2000
                })
                this.dialogkemaskinimaklumatpengguna = false
              } else {
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: `Kata Laluan Tidak Betul`,
                    timeout: 2000
                })
              }
            })
          } catch(err){
            alert(err)
          }
        }
    }
  },
  watch: {
    async kemaskinikatalaluankatalaluansemasa(val){
      if(val.length >= 8){
        console.log(`semak katalaluan`)
        const semakkatalaluan = {
            'semakkatalaluansemasa': val
        }
        const hasilsemak = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/semakkatalaluanpengguna`, semakkatalaluan)
        console.log(hasilsemak.data.status)
        if(!hasilsemak.data.status){
            this.msgkemaskinikatalaluansemasatidaksama = i18n.t('katalaluantidakbetul')
            this.kemaskinikatalaluansemasatidaksama = false
        } else {
            this.msgkemaskinikatalaluansemasatidaksama = ''
            this.kemaskinikatalaluansemasatidaksama = true
        }
      }
    },
    async kemaskiniemel(val){
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(pattern.test(val)){
        if(val !== this.semakkemaskiniemel){
            const keputusansemakemel = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/semakemel`, {semakemel:val})
            if(!keputusansemakemel.data.status){
                this.msgkemaskiniemel = i18n.t('emelsudahwujud')
                this.kemaskiniemeltidaksama = false
            } else {
                this.msgkemaskiniemel = ''
                this.kemaskiniemeltidaksama = true
            }
        }
      }
    },
    group () {
      this.drawer = false
    },
  },
};
</script>